import TratamientoAsistencialEntity from "./TratamientoAsistencialEntity";

export default class FiltrosHistoriaAdmisionEntity {

    codigoBaseDatos: string;
    uncoAdmision: number;
    firma: boolean;
    diligenciados: boolean;
    ordenCronologico: boolean;
    evoluciones: boolean;
    notas: boolean;
    triagge: boolean;
    solicitudServicios: boolean;
    especialidades: number[];
    empresas: number[];
    sede: number;
    uncoLogin: number;
    login: any;
    user: string;
    canLoad: boolean;
    canImpresion: boolean;
    ttas: TratamientoAsistencialEntity[];
    ttasSelected: TratamientoAsistencialEntity[];

    constructor() { }

    public set setFirma(firma: boolean) {
        this.firma = firma || false;
    }

    public set setEvoluciones(evoluciones: boolean) {
        this.firma = evoluciones || false;
    }
}